module.exports = __webpack_public_path__ + "static/cloud-data-4958349ed48ba07412b4009d3c5f430c.jpg";